<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div
    class="text-sm rounded-xl outline outline-1 outline-n-weak overflow-visible bg-n-solid-1"
  >
    <button
      class="flex items-center select-none w-full border-0 bg-n-alpha-1 dark:bg-n-alpha-2 m-0 cursor-grab justify-between py-2.5 px-3.5 drag-handle hover:bg-n-alpha-2 dark:hover:bg-n-alpha-3 focus-visible:outline-none"
      :class="isOpen ? 'rounded-t-xl border-b border-n-weak' : 'rounded-xl'"
      @click.stop="onToggle"
    >
      <div class="flex items-center min-w-0">
        <EmojiOrIcon
          v-if="icon || emoji"
          class="inline-block w-5"
          :icon="icon"
          :emoji="emoji"
        />
        <h5 class="text-n-slate-12 text-sm font-medium mb-0 py-0 pr-2 pl-0">
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center">
        <slot name="button" />
        <div class="flex justify-end text-n-slate-10 cursor-pointer">
          <fluent-icon v-if="isOpen" size="16" icon="subtract" type="solid" />
          <fluent-icon v-else size="16" icon="add" type="solid" />
        </div>
      </div>
    </button>
    <div v-if="isOpen" :class="compact ? 'p-0' : 'px-3.5 py-4'">
      <slot />
    </div>
  </div>
</template>
